import { Action } from '@ngrx/store';
import {
  GeneralApiResponseInterface,
  TableQueryParams,
} from '../../layout/main/main.model';
import {
  CustomFirmwareManagerFilterOutputInterface,
  FirmwareInterface,
} from './firmware-manager.model';

export enum FirmwareManagementActionTypes {
  GetFirmwares = '[Firmware] Get Firmwares',
  GetFirmwaresCompleted = '[Firmware] Get Firmwares Completed',
  GetFirmware = '[Device] Get Firmware',
  GetFirmwareCompleted = '[Device] Get Firmware Completed',
  CreateFirmware = '[Firmware] Create Firmware',
  CreateFirmwareCompleted = '[Firmware] Create Firmware Completed',
  UpdateFirmware = '[Firmware] Update Firmware',
  UpdateFirmwareCompleted = '[Firmware] Update Firmware Completed',
  DeleteFirmware = '[Firmware] Delete Firmware',
  DeleteFirmwareCompleted = '[Firmware] Delete Firmware Completed',
  UploadFirmware = '[Firmware] Upload Firmware',
  UploadFirmwareCompleted = '[Firmware] Upload Firmware Completed',
  ClearState = '[Firmware] Clear State',
  FetchError = '[Firmware] Fetch Error',
}

export class GetFirmwares implements Action {
  readonly type = FirmwareManagementActionTypes.GetFirmwares;

  constructor(
    public filters: CustomFirmwareManagerFilterOutputInterface,
    public query: TableQueryParams = {
      page: 1,
      pageSize: 10,
    },
    public timezone: string,
  ) {}
}

export class GetFirmwaresCompleted implements Action {
  readonly type = FirmwareManagementActionTypes.GetFirmwaresCompleted;

  constructor(public firmwaresList: FirmwareInterface[], public itemTotal: number) {}
}

export class GetFirmware implements Action {
  readonly type = FirmwareManagementActionTypes.GetFirmware;

  constructor(public deviceId: number) {}
}

export class GetFirmwareCompleted implements Action {
  readonly type = FirmwareManagementActionTypes.GetFirmwareCompleted;

  constructor(public firmware: GeneralApiResponseInterface<FirmwareInterface>) {}
}

export class CreateFirmware implements Action {
  readonly type = FirmwareManagementActionTypes.CreateFirmware;

  constructor(public payload: FirmwareInterface) {}
}

export class CreateFirmwareCompleted implements Action {
  readonly type = FirmwareManagementActionTypes.CreateFirmwareCompleted;

  constructor(public response: GeneralApiResponseInterface<FirmwareInterface[]>) {}
}

export class UpdateFirmware implements Action {
  readonly type = FirmwareManagementActionTypes.UpdateFirmware;

  constructor(public payload: FirmwareInterface, public id: number) {}
}

export class UpdateFirmwareCompleted implements Action {
  readonly type = FirmwareManagementActionTypes.UpdateFirmwareCompleted;

  constructor(public response: GeneralApiResponseInterface<FirmwareInterface>) {}
}

export class DeleteFirmware implements Action {
  readonly type = FirmwareManagementActionTypes.DeleteFirmware;
  constructor(public payload: number[]) {}
}

export class DeleteFirmwareCompleted implements Action {
  readonly type = FirmwareManagementActionTypes.DeleteFirmwareCompleted;
  constructor(public deletedFirmwares: any[]) {}
}

export class UploadFirmware implements Action {
  readonly type = FirmwareManagementActionTypes.UploadFirmware;
  constructor(public file: any, public firmwareId: number) {}
}

export class UploadFirmwareCompleted implements Action {
  readonly type = FirmwareManagementActionTypes.UploadFirmwareCompleted;
  constructor(public result: any) {}
}


export class ClearState implements Action {
  readonly type = FirmwareManagementActionTypes.ClearState;
}

export class FetchError implements Action {
  readonly type = FirmwareManagementActionTypes.FetchError;

  constructor(public payload: any[]) {}
}

export type FirmwareManagerActions =
  | GetFirmwares
  | GetFirmwaresCompleted
  | GetFirmware
  | GetFirmwareCompleted
  | CreateFirmware
  | CreateFirmwareCompleted
  | UpdateFirmware
  | UpdateFirmwareCompleted
  | DeleteFirmware
  | DeleteFirmwareCompleted
  | UploadFirmware
  | UploadFirmwareCompleted
  | ClearState
  | FetchError;
